/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useState } from "react";
import { Form } from "@repo/ui";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Select,
} from "@chakra-ui/react";
import { useForm, Controller } from "react-hook-form";
import { MdUpdate } from "react-icons/md";
import { useUpdateTicketStatus } from "../../../services/tickets";
import Remarks from "../../../components/forms/remarks";

const StatusLists = [{ id: "Re-Opened", text: "Re-Open" }];
export default function UpdateStatus({ requestDetails }) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    mutate: updateStatus,
    data: updateStatusResponse,
    // isPending: updatingStatus,
    // error: updateStatusError,
    // reset: resetRequest,
  } = useUpdateTicketStatus();
  useEffect(() => {
    if (updateStatusResponse) {
      setIsOpen(false);
    }
  }, [updateStatusResponse]);
  const form = useForm({
    defaultValues: { status: null, remarks: "", additionalRemarks: "" },
  });
  const generalProps = { errors: form.formState.errors, control: form.control };

  const submitInfo = (data) => {
    const payload = {
      ...data,
      jobNo: requestDetails.ticketId,
      requestId: requestDetails.ticketId,
    };
    updateStatus(payload);
  };

  return (
    <>
      <Button
        variant="outline"
        onClick={() => {
          form.reset();
          setIsOpen(true);
        }}
      >
        <MdUpdate fontSize="18px" className="text-primary font-[18px]" />
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          form.reset();
          setIsOpen(false);
        }}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Update Status</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="form-container" style={{ margin: 0 }}>
              <Form {...form}>
                <form
                  onSubmit={form.handleSubmit(submitInfo)}
                  className="add-location-form"
                >
                  <FormControl style={{ width: "100%" }}>
                    <FormLabel>Status</FormLabel>
                    <Controller
                      name="status"
                      control={form.control}
                      render={({ field }) => {
                        return (
                          <Select
                            placeholder="Select Status"
                            {...field}
                            style={{ width: "100%" }}
                          >
                            {StatusLists.map((elm, index) => (
                              <option key={index} value={elm.id}>
                                {elm.text}
                              </option>
                            ))}
                          </Select>
                        );
                      }}
                    />
                  </FormControl>

                  <Remarks
                    {...generalProps}
                    name="remarks"
                    formControlStyles={{ width: "100%" }}
                  />
                  <Remarks
                    {...generalProps}
                    name="additionalRemarks"
                    formControlStyles={{ width: "100%" }}
                  />
                  {form.formState.errors?.update ? (
                    <p className="error-message">
                      {form.formState.errors.update.message || ""}
                    </p>
                  ) : (
                    <></>
                  )}

                  <Button type="submit">Update</Button>
                  <Button
                    className="ml-2"
                    onClick={() => {
                      form.reset();
                      setIsOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </form>
              </Form>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
